import React from "react";
import "../../ModalLinkCreation/Blocks/ThumbnailPicker/Thumbnail.scss";

const Divider = ({ link, themeFontColor }) => {
  return (
    <div className="block-divider" style={{ textAlign: link.LinkAlignement }}>
      <h2 style={{ color: themeFontColor }}>{link.LinkTitle}</h2>
    </div>
  );
};

export default Divider;
